/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import t from "../../../Common/utils/translation/translator";

const AddNewAxis = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="w-full p-3 border-qds text-sm text-center cursor-pointer text-secondary flex items-center justify-center"
    >
      <MsxIcons name="plus" />
      <p>{t("integrated_drives.ui.add-new-axis")}</p>
    </div>
  );
};

AddNewAxis.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default AddNewAxis;
